import { apply, schema, SchemaPathTree } from '@angular/forms/signals';
import { emailSchema } from '../validators/email.schema';
import { IInviteUserModel } from '../../models/settings/invite-user.model';

export const inviteUserSchema = schema((path: SchemaPathTree<IInviteUserModel>) => {
  apply(path.email, emailSchema);
});
